import PropTypes from 'prop-types';

export default PropTypes.shape({}); // TODO: Do we want to fill this out again or just use flow or convert to typescript?
